import React from 'react';
import { rawHTML } from '../common';

const DoorSummary = ({name, illustration, imageAltText, isDouble, summaryValues, thumbnails, notes}) => {

  return (
    <div className="summary">
    
      {isDouble ?
        <figure className="product-illustration"><img className="door" src={illustration} alt={imageAltText} /><img className="door flip" src={illustration} alt={imageAltText} /></figure> :
        <figure className="product-illustration"><img className="door" src={illustration} alt={imageAltText} /></figure>
      }
      <h3><span>Design Number: </span><span>{name}</span></h3>

      <div className="thumbnails">
        {thumbnails.map((thumbnail) => {
          return (
            <figure key={thumbnail.value} className={thumbnail.class}>
              <div className="thumbnail" dangerouslySetInnerHTML={rawHTML(thumbnail.image)} />
              <figcaption>{thumbnail.label + ': ' + thumbnail.displayName}</figcaption>
            </figure>
          );
        })}
      </div>
      
      <h4>Specifications</h4>
      <p id="specifications">
        {summaryValues.join('; ')}
      </p>
        
      {notes ?
        <div>
          <h4>Custom features and notes</h4>
          <p id="note">
            {notes}
          </p>
        </div> : null
      }
      
    </div>
  );
};

export default DoorSummary;
